import { useState, useCallback } from "react";
import { getNotesByArgumentsURL } from "../utils/ConstantsURL";

export const useGetNotesByArguments = (token) => {
  const [note, setNote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNote = useCallback(async ({ capclave, articleWords, image = null }) => {
    if (!token) {
      const noAuthError = new Error("No hay sesión válida. Por favor inicia sesión.");
      setError(noAuthError);
      setNote(null);
      return { error: noAuthError };
    }

    setLoading(true);
    setError(null);

    try {
      const payload = { capclave };
      if (articleWords) payload.articleWords = articleWords;
      if (image && typeof image === "string" && image.trim() !== "") payload.image = image;

      const response = await fetch(getNotesByArgumentsURL(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Error al obtener la nota por argumentos");
      }

      const data = await response.json();
      setNote(data);
    } catch (err) {
      setError(err);
      setNote(null);
    } finally {
      setLoading(false);
    }
  }, [token]);

  return { note, loading, error, fetchNote };
};
